import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/punto_venta/tipoProducto';
import Tipos from './tipoProductoList';


const ms2p = (state) => {
  return {
    ...state.tipo_producto_pv,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Tipos);
